<template>
  <transition name="affiliate-toast">
    <div
      v-if="visible"
      class="affiliate-toast"
      role="status"
      aria-live="polite"
    >
      <i class="fas fa-ship" aria-hidden="true"></i>
      <div class="affiliate-toast-body">
        <p class="affiliate-toast-title">Opening {{ partnerName }} in a new tab...</p>
        <p class="affiliate-toast-subtext">
          You're heading to our booking partner to view live cabin inventory. Cruise Signals remains open right here.
        </p>
      </div>
      <button
        type="button"
        class="affiliate-toast-dismiss"
        aria-label="Dismiss notification"
        @click="dismiss"
      >
        Got it
      </button>
    </div>
  </transition>
</template>

<script>
import affiliateBus from '@/utils/affiliateBus';

const AUTO_DISMISS_MS = 4500;

export default {
  name: 'AffiliateToast',
  data() {
    return {
      visible: false,
      partnerName: 'CruiseDirect',
      timer: null
    };
  },
  mounted() {
    this.unsubscribe = affiliateBus.on(this.show);
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.clearTimer();
  },
  methods: {
    show(payload) {
      this.partnerName = (payload && payload.partnerName) || 'CruiseDirect';
      this.visible = true;
      this.clearTimer();
      this.timer = setTimeout(() => this.dismiss(), AUTO_DISMISS_MS);
    },
    dismiss() {
      this.visible = false;
      this.clearTimer();
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style scoped>
.affiliate-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 200;
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  background: var(--cs-ink);
  color: #ffffff;
  border-radius: var(--radius-pill);
  padding: 12px 20px;
  box-shadow: var(--shadow-card-hover);
  max-width: min(92vw, 560px);
}

.affiliate-toast > .fa-ship {
  color: var(--cs-signal-teal);
  font-size: 1.1rem;
  margin-top: 2px;
}

.affiliate-toast-body {
  flex: 1;
  min-width: 0;
}

.affiliate-toast-title {
  margin: 0 0 4px;
  font-weight: 700;
  font-size: var(--text-body);
  line-height: 1.3;
}

.affiliate-toast-subtext {
  margin: 0;
  font-size: var(--text-small);
  opacity: 0.9;
  line-height: 1.4;
}

.affiliate-toast-dismiss {
  align-self: center;
  flex: 0 0 auto;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
  font-size: var(--text-small);
  font-weight: 600;
  padding: 6px 12px;
  border-radius: var(--radius-pill);
  cursor: pointer;
  min-height: var(--touch-min);
  transition: background var(--transition-fast);
}

.affiliate-toast-dismiss:hover {
  background: rgba(255, 255, 255, 0.15);
}

.affiliate-toast-dismiss:focus-visible {
  outline: 2px solid var(--cs-signal-teal);
  outline-offset: 2px;
}

.affiliate-toast-enter-active,
.affiliate-toast-leave-active {
  transition: opacity var(--transition-normal), transform var(--transition-normal);
}

.affiliate-toast-enter-from,
.affiliate-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}

@media (max-width: 640px) {
  .affiliate-toast {
    flex-wrap: wrap;
    padding: 12px 16px;
  }

  .affiliate-toast-dismiss {
    width: 100%;
  }
}
</style>